import { render, staticRenderFns } from "./FutureAddressPropertyTypeRadioField.vue?vue&type=template&id=f4951750"
import script from "./FutureAddressPropertyTypeRadioField.vue?vue&type=script&lang=js"
export * from "./FutureAddressPropertyTypeRadioField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports